import "./css/policy.css";

export default function RefundPolicyPage() {
  return (
    <section className="cl-policy">
      <div className="cl-container cl-policy-inner">
        <p className="cl-eyebrow">Legal</p>
        <h1 className="cl-policy-title">Refund Policy</h1>
        <p className="cl-policy-lead">
          We aim to provide clear, reliable, and transparent support throughout every service request.
        </p>

        <div className="cl-policy-body">
          <p>
            Refund eligibility depends on the nature and stage of the service. Where a service has not yet commenced, a refund may be available subject to any applicable administrative or third-party charges.
          </p>
          <p>
            Once a service has commenced, fees may be non-refundable to the extent that work has already been performed, documents have been processed, applications have been submitted, or costs have been incurred on the client’s behalf.
          </p>
          <p>
            Government fees, court fees, official charges, and other third-party costs are generally non-refundable where they have already been paid or committed, subject to the applicable authority’s refund rules.
          </p>
          <p>
            If a service cannot be completed due to circumstances within our responsibility, we will review the matter fairly and, where appropriate, provide a refund for the unperformed portion of the service.
          </p>
          <p>
            Refund requests should be submitted through our designated communication channels and will be reviewed on a case-by-case basis in accordance with the applicable terms of service and UAE law.
          </p>
          <p>
            By requesting a service, the client acknowledges and agrees to the applicable service terms, including the refund conditions applicable to that service.
          </p>
        </div>
      </div>
    </section>
  );
}
